import { useAuthStore } from '../stores/authStore';
import { canCreate, canUpdate, canDelete } from '../utils/permissions';
import { USER_TYPES } from '../utils/constants';

export function usePermissions() {
  const user = useAuthStore((s) => s.user);
  // SuperAdmins (type=1) and ChannelAdmins (type=5) bypass all role checks.
  //
  // Roles are tenant-scoped; both types resolve to `tenantId: null`, so they
  // have no role row and the server's default-role fallback (which requires a
  // tenant) never fires — their token carries `permissions: []`. Without this
  // bypass a ChannelAdmin would see every create/edit/delete control hidden,
  // including inviting tenant admins, which is the point of the role. This
  // hook is UI gating only; the server re-resolves scope per request and 403s
  // anything genuinely out of bounds.
  if (!user || user.type === USER_TYPES.SUPER_ADMIN || user.type === USER_TYPES.CHANNEL_ADMIN) {
    return { canCreate: true, canUpdate: true, canDelete: true };
  }
  const perms = user.permissions || [];
  return {
    canCreate: canCreate(perms),
    canUpdate: canUpdate(perms),
    canDelete: canDelete(perms),
  };
}
